module.exports = __webpack_public_path__ + "img/bg.cd8ba6d4.jpg";